<template>
  <generic-modal :title="$t('payroll')" ref="generic_modal" size="fullscreen">
    <div class="columns">
      <div class="column is-5">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("name") }}</label>
              <div class="control">
                <input type="text" class="input" v-model="meta.name" />
              </div>
            </div>
          </div>
          <div class="column is-5">
            <div class="field">
              <label class="label">{{ $t("status") }}</label>
              <div class="select">
                <select v-model="meta.status">
                  <option value="pending">{{ $t("pending") }}</option>
                  <option value="processed">{{ $t("processed") }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("from date") }}</label>
              <div class="control">
                <input type="date" class="input" v-model="meta.from_date" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("to date") }}</label>
              <div class="control">
                <input type="date" class="input" v-model="meta.to_date" />
              </div>
            </div>
          </div>
        </div>
        <div class="field" v-if="meta.settings">
          <label class="checkbox">
            <input type="checkbox" v-model="meta.settings.include_salary" />
            {{ $t("include salary") }}
          </label>
        </div>
        <div class="field" v-if="meta.settings">
          <label class="label">{{ $t("notes") }}</label>
          <div class="control">
            <textarea
              class="textarea"
              v-model="meta.settings.notes"
              rows="2"
            ></textarea>
          </div>
        </div>
        <div class="field">
          <label class="label">{{ $t("total payroll") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              :value="format_currency(total_payroll)"
              disabled
            />
          </div>
        </div>
      </div>
      <div class="column">
        <table class="table is-fullwidth is-striped is-hoverable">
          <thead>
            <tr>
              <th>{{ $t("name") }}</th>
              <th>{{ $t("salary") }}</th>
              <th>{{ $t("bonus") }}</th>
              <th>{{ $t("deductions") }}</th>
              <th>{{ $t("total") }}</th>
            </tr>
          </thead>
          <tbody v-if="meta.active_members">
            <tr
              v-for="member in meta.active_members.filter(
                (m) => m.is_getting_paid
              )"
              :key="member.uuid"
            >
              <td>
                <label class="checkbox">
                  <input type="checkbox" v-model="member.is_getting_paid" />
                  {{ member.first_name }} {{ member.first_surname }}
                </label>
              </td>
              <td>
                <span v-if="meta.settings?.include_salary">{{
                  format_currency(member.salary)
                }}</span>
                <span v-else>{{ format_currency(0) }}</span>
              </td>
              <td>
                <div class="control">
                  <input
                    type="number"
                    class="input"
                    v-model="member.bonus"
                    style="max-width: 120px"
                  />
                </div>
              </td>
              <td>
                <div class="control">
                  <input
                    type="number"
                    class="input"
                    v-model="member.deductions"
                    style="max-width: 120px"
                  />
                </div>
              </td>
              <td>
                {{
                  format_currency(
                    (meta.settings?.include_salary
                      ? Number(member.salary)
                      : 0) +
                      Number(member.bonus || 0) -
                      Number(member.deductions || 0)
                  )
                }}
              </td>
            </tr>
            <tr
              v-for="member in meta.active_members.filter(
                (m) => !m.is_getting_paid
              )"
              :key="member.uuid"
            >
              <td>
                <label class="checkbox">
                  <input type="checkbox" v-model="member.is_getting_paid" />
                  {{ member.first_name }} {{ member.first_surname }}
                </label>
              </td>
              <td>{{ format_currency(member.salary) }}</td>
              <td>
                {{ format_currency(member.bonus || 0) }}
              </td>
              <td>
                {{ format_currency(member.deductions || 0) }}
              </td>
              <td>
                {{
                  format_currency(
                    Number(member.salary) +
                      Number(member.bonus || 0) -
                      Number(member.deductions || 0)
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>

    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  format_currency,
  generate_error_message_text,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "PayrollModal",
  components: {
    GenericModal,
    GenericDropdown,
  },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.name ||
        !v.meta.from_date ||
        !v.meta.to_date ||
        !v.meta.active_members ||
        v.total_payroll <= 0
      );
    },
    total_payroll() {
      let v = this;
      let include_salary = v.meta.settings?.include_salary || false;
      if (!v.meta.active_members) return 0;
      return v.meta.active_members
        .filter((m) => m.is_getting_paid)
        .reduce((sum, member) => {
          return (
            sum +
            (include_salary ? Number(member.salary) : 0) +
            Number(member.bonus || 0) -
            Number(member.deductions || 0)
          );
        }, 0);
    },
  },
  methods: {
    format_currency,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    open() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
      v.get_active_members();
    },
    edit(uuid) {
      let v = this;
      v.set_initial_state();
      get("/staff/payroll", { uuid: uuid })
        .then((response) => {
          v.meta = { ...response, uuid: uuid };
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$refs.generic_modal.show_modal();
        });
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      data.active_members = data.active_members
        .filter((m) => m.is_getting_paid)
        .map((m) => {
          return {
            id: m.member_id,
            salary: m.salary,
            bonus: m.bonus || 0,
            deductions: m.deductions || 0,
          };
        });
      if (!data.uuid) {
        put("/staff/payroll", data)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        post("/staff/payroll", data)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {
          include_salary: true,
        },
        active_members: [],
      };
      v.error = "";
    },
    get_active_members() {
      let v = this;
      get("/staff/member/all", {})
        .then((response) => {
          v.meta.active_members = response.map((m) => {
            return { ...m, is_getting_paid: true, bonus: 0, deductions: 0 };
          });
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
  },
  mounted() {},
  created() {},
  watch: {},
};
</script>
<style></style>
